import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import useIsMobile from 'hooks/useIsMobile';
import type React from 'react';
import { Link } from 'react-router-dom';

import { getNavItemButtonSx } from './sidebar.styles';
import type { NavItem } from './sidebar.types';

interface NavButtonProps {
  item: NavItem;
  isActive: boolean;
  collapsed: boolean;
  onMobileClose: () => void;
}

const wrapperSx = (collapsed: boolean) => ({
  px: collapsed ? '8px' : '12px',
  py: '1px',
  transition: 'padding 0.46s cubic-bezier(0.25, 0.8, 0.25, 1)',
});

const NavButton: React.FC<NavButtonProps> = ({ item, isActive, collapsed, onMobileClose }) => {
  const { isMobile } = useIsMobile();

  const handleClick = () => {
    if (item.onClick) item.onClick();
    if (isMobile) onMobileClose();
  };

  const button = (
    <ListItemButton sx={getNavItemButtonSx(isActive, collapsed)} onClick={item.onClick ? handleClick : undefined}>
      <ListItemIcon>{item.icon}</ListItemIcon>
      <ListItemText primary={item.text} />
    </ListItemButton>
  );

  // onClick items don't use Link navigation
  if (item.onClick) {
    return (
      <Box data-nav-active={isActive || undefined} sx={wrapperSx(collapsed)}>
        {collapsed ? (
          <Tooltip title={item.text} placement="right" enterDelay={300} enterNextDelay={200}>
            {button}
          </Tooltip>
        ) : (
          button
        )}
      </Box>
    );
  }

  const linked = (
    <Link
      to={item.path}
      onClick={() => {
        if (isMobile) onMobileClose();
      }}
      style={{ textDecoration: 'none' }}
    >
      {button}
    </Link>
  );

  return (
    <Box data-nav-active={isActive || undefined} sx={wrapperSx(collapsed)}>
      {collapsed ? (
        <Tooltip title={item.text} placement="right" enterDelay={300} enterNextDelay={200}>
          {linked}
        </Tooltip>
      ) : (
        linked
      )}
    </Box>
  );
};

export default NavButton;
